module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 npd block versiculo__slider"
  }, [_c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "myCarousel",
      "data-ride": "carousel",
      "data-interval": "false"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "carousel-inner"
  }, _vm._l((_vm.versiculos), function(versiculo) {
    return _c('div', {
      staticClass: "item"
    }, [(versiculo.better_featured_image != null) ? _c('figure', {
      staticClass: "hidden-xs hidden-sm col-md-3"
    }, [_c('img', {
      staticClass: "shadow",
      attrs: {
        "src": versiculo.better_featured_image.media_details.sizes['306x307'].source_url,
        "alt": ""
      }
    })]) : _c('figure', {
      staticClass: "hidden-xs hidden-sm col-md-3"
    }, [_c('img', {
      staticClass: "shadow",
      attrs: {
        "src": _vm.theme_url + '/html/assets/img/versiculo.jpg',
        "alt": ""
      }
    })]), _vm._v(" "), _c('article', {
      staticClass: "col-xs-12 col-md-9 versiculo__des"
    }, [_c('h3', [_vm._v("Versículo del día")]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(versiculo.excerpt.rendered)
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "cita"
    }, [_vm._v(_vm._s(versiculo.title.rendered))]), _vm._v(" "), _c('div', {
      staticClass: "compartir"
    }, [_c('span', [_vm._v("Compartir en")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
      attrs: {
        "href": 'https://www.facebook.com/sharer/sharer.php?u=' + versiculo.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-facebook"
    })])]), _vm._v(" "), _c('li', [_c('a', {
      attrs: {
        "href": 'https://twitter.com/share?text=' + versiculo.link,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-twitter"
    })])]), _vm._v(" "), _c('li', {
      staticClass: "itemwa"
    }, [_c('a', {
      attrs: {
        "href": 'whatsapp://send?text=' + versiculo.soloexcerpt + ' ' + versiculo.title.rendered + ' ' + versiculo.link
      }
    }, [_c('i', {
      staticClass: "fa fa-whatsapp"
    })])])])])])])
  }))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#myCarousel",
      "data-slide": "prev"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#myCarousel",
      "data-slide": "next"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a7014ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/versiculodeldia.vue
// module id = 127
// module chunks = 0